// SurveyNavigation.jsx - Versión optimizada para móvil

import React from 'react';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

const SurveyNavigation = ({
  activeStep = 0,
  activeStepper = 0,
  activeDemographicStep = 0,
  totalSteps = 1,
  totalDemographicSteps = 1,
  nameStep = [],
  primaryColor = '#03aae4',
  secondaryColor = '#ffffff',
  onNext,
  onBack,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const isInDemographicStep = () => {
    return nameStep && nameStep[activeStepper] === 'Datos demográficos';
  };

  const getNextButtonText = () => {
    if (
      isInDemographicStep() &&
      activeDemographicStep + 1 === totalDemographicSteps
    ) {
      return 'Continuar';
    }

    if (!isInDemographicStep() && activeStep + 1 === totalSteps) {
      return 'Finalizar';
    }

    return 'Siguiente';
  };

  const isBackButtonDisabled = () => {
    if (
      isInDemographicStep() &&
      activeDemographicStep === 0 &&
      activeStepper === 0
    ) {
      return true;
    }

    if (
      !isInDemographicStep() &&
      activeStep === 0 &&
      (activeStepper === 0 ||
        nameStep[activeStepper - 1] !== 'Datos demográficos')
    ) {
      return true;
    }

    return false;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        mt: 4,
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: 600,
          margin: '0 auto',
          width: '100%',
          padding: { xs: '12px 8px', sm: '16px 24px' },
          gap: { xs: 1, sm: 4 }, // ✅ Menos espacio en móvil
        }}
      >
        {/* Botón Atrás */}
        <Button
          size="small"
          onClick={onBack}
          disabled={isBackButtonDisabled()}
          sx={{
            color: primaryColor,
            minWidth: 'auto', // ✅ Sin ancho mínimo en móvil
            padding: { xs: '6px 8px', sm: '8px 16px' },
            textTransform: 'none',
            fontWeight: 600,
            fontSize: { xs: '12px', sm: '14px' },
            '&:hover': {
              backgroundColor: `${primaryColor}15`,
            },
            '&.Mui-disabled': {
              color: 'rgba(0, 0, 0, 0.26)',
            },
          }}
        >
          {isMobile ? (
            <KeyboardArrowLeft fontSize="small" />
          ) : (
            <>
              <KeyboardArrowLeft fontSize="small" />
              Atrás
            </>
          )}
        </Button>

        {/* Contador de pasos - HORIZONTAL en móvil */}
        <Typography
          variant="body2"
          sx={{
            color: 'text.primary',
            fontWeight: 700,
            fontSize: { xs: '14px', sm: '16px' },
            textAlign: 'center',
            whiteSpace: 'nowrap', // ✅ Evita salto de línea
            padding: { xs: '4px 12px', sm: '8px 16px' },
            backgroundColor: `${primaryColor}10`,
            borderRadius: '20px',
            border: `1px solid ${primaryColor}30`,
          }}
        >
          {activeStep + 1} / {totalSteps}
        </Typography>

        {/* Botón Siguiente/Finalizar */}
        <Button
          size="small"
          onClick={onNext}
          sx={{
            color: primaryColor,
            minWidth: 'auto', // ✅ Sin ancho mínimo en móvil
            padding: { xs: '6px 12px', sm: '8px 16px' },
            textTransform: 'none',
            fontWeight: 600,
            fontSize: { xs: '12px', sm: '14px' },
            whiteSpace: 'nowrap', // ✅ Evita salto de línea
            '&:hover': {
              backgroundColor: `${primaryColor}15`,
            },
          }}
        >
          {isMobile ? (
            <>
              {getNextButtonText().substring(0, 8)}
              {getNextButtonText().length > 8 && '...'}
              <KeyboardArrowRight fontSize="small" />
            </>
          ) : (
            <>
              {getNextButtonText()}
              <KeyboardArrowRight fontSize="small" />
            </>
          )}
        </Button>
      </Box>
    </Box>
  );
};

SurveyNavigation.propTypes = {
  activeStep: PropTypes.number,
  activeStepper: PropTypes.number,
  activeDemographicStep: PropTypes.number,
  totalSteps: PropTypes.number,
  totalDemographicSteps: PropTypes.number,
  nameStep: PropTypes.arrayOf(PropTypes.string),
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default SurveyNavigation;